<template>
	<div class="moonSampleSearchClass">
		<div class="moonContent" v-if="!inforFlag && !editInforFlag">
			<span class="moonClass" v-if="borrwingFlag">{{ $t('MoonSample.MoonSampleSearch') }}</span>
			<div class="searchDivClass">
				<div class="titleNameClass">
					<div style="display: flex">
						<span class="lineClass"></span>
						<span class="sampleTypeClass">{{ $t('MoonSample.SampleType') }}</span>
					</div>

					<div class="inforNameClass">
						<div class="spanDivClass" v-for="(item, index) in inforArr" :key="index">
							<span class="nameClass" v-if="item && item[0]">{{ lang == 'zh-CN' ? item[0].level : item[0].levelEn }}</span>
							<span
								:class="activeItem.includes(itemChild.name) ? 'typeClass1' : 'typeClass2'"
								v-for="(itemChild, indexC) in item"
								:key="indexC"
								@click="changeSampleType(itemChild, indexC)"
								>{{ lang == 'zh-CN' ? itemChild.name : itemChild.nameEn }}</span
							>
						</div>
					</div>
				</div>
				<!-- <div class="inforNameClass">
					<div class="spanDivClass" v-for="(item, index) in inforArr" :key="index">
						<span class="nameClass" v-if="item && item[0]">{{ item[0].level }}</span>
						<span
							:class="activeItem.includes(itemChild.name) ? 'typeClass1' : 'typeClass2'"
							v-for="(itemChild, indexC) in item"
							:key="indexC"
							@click="changeSampleType(itemChild, indexC)"
							>{{ itemChild.name }}</span
						>
					</div>
				</div> -->
				<div class="sampleEditClass">
					<div class="sampleNum">
						<div class="sampleNumTitleClass">
							<span class="lineClass"></span>
							<span class="sampleNumClass">{{ $t('MoonSample.SampleCode') }}</span>
						</div>

						<el-input v-model="sampleObj.code" clearable :placeholder="$t('MoonSample.SampleCode')"></el-input>
					</div>
					<div class="sampleNum">
						<div class="sampleNumTitleClass">
							<span class="lineClass"></span>
							<span class="sampleNumClass">{{ $t('MoonSample.IssuedWeight') }}</span>
						</div>
						<div class="weightClass" style="display: flex; align-items: baseline">
							<el-input style="width: 100px" v-model="sampleObj.currentWeightMin" clearable></el-input>g
							<span style="margin: 4px"> - </span>
							<el-input style="width: 100px" v-model="sampleObj.currentWeightMax" clearable></el-input>g
						</div>
					</div>
				</div>
				<div class="sampleEditClass">
					<div class="sampleNum">
						<div class="sampleNumTitleClass">
							<span class="lineClass"></span>
							<span class="sampleNumClass">{{ $t('MoonSample.SampleFeature') }}</span>
						</div>
						<el-input v-model="sampleObj.sampleType" :placeholder="$t('MoonSample.SampleFeature')" clearable></el-input>
					</div>
					<div class="sampleNum">
						<div class="sampleNumTitleClass">
							<span class="lineClass"></span>
							<span class="sampleNumClass">{{ $t('MoonSample.UseStatus') }}</span>
						</div>
						<div style="display: flex; justify-content: space-between; align-items: baseline">
							<el-select style="width: 130px" v-model="sampleObj.statusList" clearable :placeholder="$t('MoonSample.PleaseSelect')">
								<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"> </el-option>
							</el-select>
							<el-button class="btnClass" size="small" icon="el-icon-search" @click="searchSampleFunc()">{{ $t('MoonSample.Submit') }}</el-button>
						</div>
					</div>
				</div>
			</div>
			<div class="tableDataClass">
				<div style="text-align: left">
					{{ $t('MoonSample.SearchResults', { total: totalMoonSample }) }}，{{ $t('MoonSample.CanApply') }}：{{ $t('MoonSample.Total') }}{{ totalCount.available_apply_count
					}}{{ $t('MoonSample.Records') }}，{{ $t('MoonSample.BorrowingReview') }}：{{ $t('MoonSample.Total') }}{{ totalCount.under_review_count }}{{ $t('MoonSample.Records') }}，{{
						$t('MoonSample.Borrowing')
					}}：{{ $t('MoonSample.Total') }}{{ totalCount.borrowing_count }}{{ $t('MoonSample.Records') }}，{{ $t('MoonSample.ReturnMonitoring') }}：{{ $t('MoonSample.Total')
					}}{{ totalCount.return_test_count }}{{ $t('MoonSample.Records') }}
				</div>
				<el-table :data="moonSampleTableData" stripe :height="500" style="width: 100%">
					<el-table-column type="index" width="50" align="center"></el-table-column>
					<el-table-column :label="$t('MoonSample.SampleCode')" width="220">
						<template slot-scope="scope">
							<div :title="scope.row.code" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis">
								{{ scope.row.code }}
							</div>
						</template>
					</el-table-column>
					<el-table-column :label="$t('MoonSample.SampleType')" :width="220" align="left">
						<template slot-scope="scope">
							{{ scope.row.sampleCategory1 != null ? scope.row.sampleCategory1 : '' }}
							{{ scope.row.sampleCategory2 != null ? '/' + scope.row.sampleCategory2 : '' }}
							{{ scope.row.sampleCategory3 != null ? '/' + scope.row.sampleCategory3 : '' }} {{ scope.row.sampleCategory4 != null ? '/' + scope.row.sampleCategory4 : '' }}
						</template>
					</el-table-column>

					<el-table-column prop="sampleType" :label="$t('MoonSample.SampleFeature')">
						<template slot-scope="scope">
							<span v-html="scope.row.sampleType" style="font-size: unset"></span>
						</template>
					</el-table-column>
					<el-table-column prop="num" :label="$t('MoonSample.Quantity')" align="center">-- </el-table-column>
					<el-table-column prop="availableWeight" :label="$t('MoonSample.Weight')" align="center"> </el-table-column>
					<el-table-column prop="lidu" :label="$t('MoonSample.ParticleSize')" :width="120" align="center"> --</el-table-column>
					<el-table-column :label="$t('MoonSample.PhotoSampleInfo')">
						<template slot-scope="scope">
							<img v-if="scope.row.images && scope.row.images[0]" style="width: 44px; height: 44px" :src="scope.row.images[0].thumbnail.split(',')[0]" />
							<span v-else>--</span>
						</template>
					</el-table-column>
					<el-table-column :label="$t('MoonSample.UseStatus')"
						><template slot-scope="scope">
							<span v-if="scope.row.status == 0">{{ $t('MoonSample.Unavailable') }}</span>
							<span v-else-if="scope.row.status == 1">{{ $t('MoonSample.CanApply') }}</span>
							<span v-else-if="scope.row.status == 2">{{ $t('MoonSample.PendingSampling') }}</span>
							<span v-else-if="scope.row.status == 3">{{ $t('MoonSample.Borrowing') }}</span>
							<span v-else-if="scope.row.status == 5">{{ $t('MoonSample.ReturnMonitoring') }}</span>
							<span v-else>{{ $t('MoonSample.BorrowingReview') }}</span>
						</template>
					</el-table-column>
					<el-table-column :label="$t('MoonSample.Operation')" :width="60">
						<template slot-scope="scope">
							<el-button @click="handleInforClick(scope.row)" type="text" size="small">{{ $t('MoonSample.Details') }}</el-button>
						</template>
					</el-table-column>
				</el-table>
				<div class="block" style="background-color: #fff; height: 50px; display: flex; justify-content: end; align-items: center">
					<el-pagination
						@size-change="handleSizeChange"
						@current-change="handleCurrentChange"
						:current-page="currentPage"
						:page-sizes="[10, 20, 50, 100]"
						:page-size="pageSize"
						background
						layout="total, sizes, prev, pager, next, jumper"
						:total="totalMoonSample"
					>
					</el-pagination>
				</div>
			</div>
		</div>
		<sampleInfor v-if="inforFlag" ref="sampleInfoRef" @goBackFunc="goBackFunc"></sampleInfor>
		<editMoonSampleInfor v-if="editInforFlag" ref="editSampleRef" @goBackFunc="goBackFunc"></editMoonSampleInfor>
	</div>
</template>

<script>
import sampleInfor from '../sampleSearch/moonSampleInfor.vue'
import editMoonSampleInfor from '../sampleSearch/editMoonSampleInfor.vue'
export default {
	name: 'moonSampleIndex',
	props: {},
	components: {
		sampleInfor,
		editMoonSampleInfor
	},
	data() {
		return {
			lang: this.$i18n.locale,
			totalCount: {},
			borrwingFlag: true,
			activeItem: [],
			activeLevel: [],
			activeItemObj: [],
			sampleObj: {
				code: '',
				sampleType: '',
				statusList: [],
				currentWeight: '',
				currentWeightMax: '',
				currentWeightMin: ''
			},
			inforFlag: false,
			editInforFlag: false,
			moonSampleTableData: [],
			sampleNum: '',
			inforArr: [[{ level: '一级', itemChild: [] }]],
			currentPage: 1,
			pageSize: 10,
			totalMoonSample: 0
		}
	},
	computed: {
		options() {
			return [
				{ value: '1', label: this.$t('MoonSample.CanApply') },
				{ value: '3', label: this.$t('MoonSample.Borrowing') },
				{ value: '4', label: this.$t('MoonSample.BorrowingReview') },
				{ value: '5', label: this.$t('MoonSample.ReturnMonitoring') }
			]
		}
	},
	mounted() {
		this.getMoonSampleListFunc()
		this.initFunc()
		this.getMoonSampleStatusCount()
	},
	methods: {
		handleCurrentChange(val) {
			this.currentPage = val
			this.initFunc()
		},
		handleSizeChange(val) {
			this.pageSize = val
			this.initFunc()
		},
		changeSampleType(itemObj) {
			if (this.activeLevel.includes(itemObj.level) && this.activeItem.includes(itemObj.name)) {
				this.activeItem.forEach((element, index) => {
					if (element == itemObj.name) {
						this.activeItem.splice(index, 1)
						this.activeItemObj.splice(index, 1)
						this.activeLevel.splice(index, 1)
					}
				})
			} else {
				if (this.activeLevel.includes(itemObj.level)) {
					this.activeItemObj.forEach((element, indexObj) => {
						if (element.level == itemObj.level) {
							this.activeItem.splice(indexObj, 1)
							this.activeItemObj.splice(indexObj, 1)
							this.activeLevel.splice(indexObj, 1)
						}
					})
				}
				this.activeItem.push(itemObj.name)
				this.activeItemObj.push(itemObj)
				this.activeLevel.push(itemObj.level)
			}
			console.log(this.activeItemObj)
		},
		searchSampleFunc() {
			this.initFunc()
		},
		async getMoonSampleListFunc() {
			this.inforArr[0] = []
			this.inforArr[1] = []
			this.inforArr[2] = []
			this.inforArr[3] = []
			let res = await this.$http.get(this.$const.moonSample.getMoonSampleTypeList + `?pageNum=1&pageSize=100`)
			if (res && res.code == 200) {
				const resultData = res.data
				resultData.forEach((element) => {
					if (element.level == '一级') {
						this.inforArr[0].push(element)
					} else if (element.level == '二级') {
						this.inforArr[1].push(element)
					} else if (element.level == '三级') {
						this.inforArr[2].push(element)
					} else {
						this.inforArr[3].push(element)
					}
				})
			}
		},
		async initFunc() {
			let sampleCategory1 = '',
				sampleCategory2 = '',
				sampleCategory3 = '',
				sampleCategory4 = ''

			if (this.activeItemObj && this.activeItemObj.length > 0) {
				this.activeItemObj.forEach((element) => {
					if (element.level == '一级') {
						sampleCategory1 += element.code + ','
					} else if (element.level == '二级') {
						sampleCategory2 += element.code + ','
					} else if (element.level == '三级') {
						sampleCategory3 += element.code + ','
					} else if (element.level == '四级') {
						sampleCategory4 += element.code + ','
					}
				})
				const reg = /,$/gi
				sampleCategory1 = sampleCategory1.replace(reg, '')
				sampleCategory2 = sampleCategory2.replace(reg, '')
				sampleCategory3 = sampleCategory3.replace(reg, '')
				sampleCategory4 = sampleCategory4.replace(reg, '')
			}
			const params = {
				pageNum: this.currentPage,
				pageSize: this.pageSize
			}
			if (sampleCategory1 !== '') params.sampleCategory1 = sampleCategory1
			if (sampleCategory2 !== '') params.sampleCategory2 = sampleCategory2
			if (sampleCategory3 !== '') params.sampleCategory3 = sampleCategory3
			if (sampleCategory4 !== '') params.sampleCategory4 = sampleCategory4
			if (this.sampleObj.code !== '') params.code = this.sampleObj.code
			if (this.sampleObj.sampleType !== '') params.sampleType = this.sampleObj.sampleType
			if (this.sampleObj.status !== '') params.status = this.sampleObj.status
			if (this.sampleObj.currentWeight !== '') params.currentWeight = this.sampleObj.currentWeight
			if (this.sampleObj.statusList !== '') params.statusList = this.sampleObj.statusList
			if (this.sampleObj.currentWeightMax !== '') params.currentWeightMax = this.sampleObj.currentWeightMax
			if (this.sampleObj.currentWeightMin !== '') params.currentWeightMin = this.sampleObj.currentWeightMin

			let res = await this.$http.get(this.$const.moonSample.getMoonSampleList, params)
			if (res && res.code == 200) {
				this.moonSampleTableData = res.rows
				this.totalMoonSample = res.total
			}
		},
		async getMoonSampleStatusCount() {
			let res = await this.$http.get(this.$const.moonSample.getMoonSampleStatusCount)
			if (res && res.code == 200) {
				this.totalCount = res.data
			}
		},
		async handleInforClick(row) {
			console.log(row)
			// this.inforFlag = true
			// this.$nextTick(() => {
			// 	this.$refs.sampleInfoRef.initDataFunc(row)
			// })
			await this.$http.get(this.$const.moonSample.viewsInfo + `/${row.id}`)
			this.$nextTick(() => {
				// this.$refs.sampleInfoRef.initDataFunc(row)
				window.open(this.$router.resolve({ path: `/moonSampleInfor`, query: { obj: JSON.stringify(row) } }).href, '_blank')
				// this.$router.push({ path: '/moonSampleInfor', query: { obj: row } }) // 传递查询参数q=vue
			})
		},
		editSample(row) {
			console.log(row)
			this.editInforFlag = true
			this.$nextTick(() => {
				this.$refs.editSampleRef.initDataFunc(row)
			})
		},
		goBackFunc(type) {
			if (type == 1) {
				this.inforFlag = false
			} else {
				this.editInforFlag = false
			}
		}
	}
}
</script>

<style lang="scss" scoped>
.moonSampleSearchClass {
	width: 100%;
	// height: 1510px;
	text-align: center;
	background: #f0f5ff;
	margin-bottom: 20px;
	.moonContent {
		width: 1200px;
		text-align: center;
		display: inline-block;
		.moonClass {
			font-size: 28px;
			color: #000000;
			display: block;
			text-align: left;
			margin-top: 20px;
			margin-bottom: 20px;
		}
		.searchDivClass {
			display: flex;
			// height: 246px;
			background: #ffffff;
			border-radius: 4px;
			border: 1px solid rgba(21, 65, 140, 0.2);
			margin-bottom: 22px;
			padding: 10px;
			height: 280px;
			justify-content: space-around;
			.titleNameClass {
				// display: flex;
				display: block;
				justify-content: left;
				align-items: center;
				height: 30px;
				padding: 5px;
				.lineClass {
					width: 2px;
					height: 16px;
					background: #15418c;
				}
				.sampleTypeClass {
					height: 21px;
					font-family: MicrosoftYaHeiUISemibold;
					font-size: 16px;
					color: #000000;
					line-height: 21px;
					text-align: left;
					font-style: normal;
					display: block;
					margin-left: 8px;
				}
			}

			.sampleEditClass {
				display: flex;
				// justify-content: space-around;
				align-items: baseline;
				margin-top: 10px;
				flex-direction: column;
				padding-right: 20px;
				.sampleNum {
					// width: 280px;
					padding: 6px;
					.sampleNumTitleClass {
						display: flex;
						align-items: center;
						margin-bottom: 8px;
						.lineClass {
							width: 2px;
							height: 16px;
							background: #15418c;
						}
						.sampleNumClass {
							height: 21px;
							font-family: MicrosoftYaHeiUISemibold;
							font-size: 16px;
							color: #000000;
							line-height: 21px;
							text-align: left;
							font-style: normal;
							display: block;
							margin-left: 8px;
						}
					}
				}
			}
			.inforNameClass {
				display: flex;
				justify-content: left;
				align-items: baseline;
				flex-wrap: wrap;
				flex-direction: column;
				.spanDivClass {
					display: flex;
					justify-content: stretch;
					-webkit-box-align: baseline;
					align-items: center;
					padding: 8px;
					// width: 50%;
					height: 60px;
				}
				.nameClass {
					width: 50px;
					margin-right: 10px;
					height: 40px;
					font-family: MicrosoftYaHeiUI;
					font-size: 16px;
					color: #000000;
					line-height: 21px;
					text-align: left;
					font-style: normal;
					display: flex;
					justify-content: center;
					align-items: center;
				}
				.typeClass2:hover,
				.typeClass1 {
					// width: 116px;
					min-width: 120px;
					max-width: max-content;
					margin-right: 5px;
					height: 40px;
					background: #15418c;
					border-radius: 4px;
					color: #ffffff;
					display: flex;
					justify-content: center;
					align-items: center;
				}
				.typeClass2 {
					// width: 116px;
					height: 40px;
					min-width: 120px;
					max-width: max-content;
					margin-right: 5px;
					background: radial-gradient(396% 161% at 50% 0%, rgba(21, 65, 140, 0.3) 0%, rgba(21, 65, 140, 0) 100%);
					border-radius: 4px;
					display: flex;
					justify-content: center;
					align-items: center;
					cursor: pointer;
				}
			}
			.btnClass {
				background: #15418c;
				border-radius: 4px;

				font-family: MicrosoftYaHeiUI;
				font-size: 16px;
				color: #ffffff;
				line-height: 21px;
				text-align: left;
				font-style: normal;
				line-height: 10px;
				text-align: left;
				font-style: normal;
				margin-top: 5px;
			}
		}
	}
}
</style>
<style >
.el-table th.el-table__cell.is-leaf {
	background-color: #15418c;
	color: #ffffff;
}
.el-table tr {
	background: #f0f5ff;
}
.el-table--enable-row-transition .el-table__body td.el-table__cell {
	color: #333333;
	font-size: 14px;
}
.sampleNum .el-input__inner {
	/* width: 280px; */
	height: 36px;
	background: #ffffff;
	border-radius: 4px;
	border: 1px solid #cccccc;
}
.weightClass .el-input__inner {
	width: 100%;
}
</style>